import { render, staticRenderFns } from "./user-license.vue?vue&type=template&id=6e736c5a&scoped=true&"
import script from "./user-license.vue?vue&type=script&lang=js&"
export * from "./user-license.vue?vue&type=script&lang=js&"
import style0 from "./user-license.vue?vue&type=style&index=0&id=6e736c5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e736c5a",
  null
  
)

export default component.exports